import * as React from 'react';
import { MediaQuery } from '@grandvisionhq/common';
import { ConfigurationTotalPriceContainer } from '../ConfigurationTotalPrice/ConfigurationTotalPriceContainer.js';
import FrameInformation from '../../../steps/components/FrameInformation/FrameInformationContainer.js';

const RxGlassesTopBar = ()=>{
    const isPhone = MediaQuery.useIsPhone();
    return /*#__PURE__*/ React.createElement("div", {
        className: "rxglasses-topbar"
    }, !isPhone && /*#__PURE__*/ React.createElement(FrameInformation, null), /*#__PURE__*/ React.createElement(ConfigurationTotalPriceContainer, null));
};

export { RxGlassesTopBar };
//# sourceMappingURL=RxGlassesTopBar.js.map
